const Helper = {
  getFormData (data, previousKey, formData) {
    if (formData === undefined) {
      formData = new FormData()
    }
    Object.keys(data).forEach(key => {
      const value = data[key]
      if (previousKey) {
        key = `${previousKey}[${key}]`
      }
      if (value instanceof File) {
        formData.append(key, value)
      } else if (value instanceof Object && !Array.isArray(value)) {
        Helper.getFormData(value, key, formData)
      } else if (Array.isArray(value)) {
        value.forEach(val => {
          formData.append(`${key}[]`, val)
        })
      } else {
        formData.append(key, value)
      }
    })
    return formData
  }
}

export default Helper



// WEBPACK FOOTER //
// ./src/helper/helper.js